import { useState } from 'react';

export interface DrawerApi {
  open: () => void;
  close: () => void;
  isOpen: boolean;
}

export interface DrawerTestDefaults {
  initialOpenState: boolean;
}

/**
 * @param testDefaults - ONLY USE FOR TESTING PURPOSES
 */
export const useDrawer = (testDefaults?: DrawerTestDefaults): DrawerApi => {
  const [isOpen, setIsOpen] = useState(testDefaults ? testDefaults.initialOpenState : false);

  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  return {
    open,
    close,
    isOpen,
  };
};
